import * as React from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { getAffiliateForm } from '../../../Model/AffiliateModel'

export interface IAffiliatePageProps {
    httpActionsService: HttpActionsService
    userStore?: UserStore
    localizationStore?: LocalizationStore
}

@inject('httpActionsService')
@inject('userStore')
@inject('localizationStore')
@observer
class AffiliatePage extends React.Component<IAffiliatePageProps> {
    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }
        this.props.httpActionsService!.getAffiliate(this.props['match']!['params']['id'])
    }

    render() {
        const { localizationStore } = this.props
        return (
            <div className="affiliatePage row">
                <div className="col-12">
                    <h4>{localizationStore!.t('AffiliatePageHeader')}</h4>
                </div>
                <div className="col-12">
                    {getAffiliateForm()}
                </div>
            </div>
        )
    }
}

export default withRouter(AffiliatePage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Affiliate/AffiliatePage.tsx